const SHADOW_JUNINA_TEXT = '0 0 12px rgba(234,179,8,0.4)';

// Cores das bandeirinhas — paleta clássica de Festa Junina
const CORES_VARAL = [
  '#dc2626', // vermelho
  '#f97316', // laranja
  '#eab308', // amarelo
  '#16a34a', // verde
  '#2563eb', // azul
  '#9333ea', // roxo
];

// Confetes que caem (posição x, delay, cor)
const CONFETES = [
  { left: 8,  delay: '0.0s', cor: '#fbbf24' },
  { left: 22, delay: '0.4s', cor: '#f97316' },
  { left: 38, delay: '0.8s', cor: '#dc2626' },
  { left: 55, delay: '0.2s', cor: '#16a34a' },
  { left: 70, delay: '1.0s', cor: '#fbbf24' },
  { left: 84, delay: '0.5s', cor: '#9333ea' },
];

/**
 * JukeboxJuninaBanner — faixa festiva exibida no topo do Jukebox
 * quando uma música de Invasão Junina está tocando na TV.
 *
 * Não substitui o layout — aparece entre o header e o conteúdo
 * como um banner animado que tematiza a sessão.
 */
export default function JukeboxJuninaBanner() {
  const totalBandeiras = 20;

  return (
    <div className="animate-fade-in overflow-hidden relative">

      {/* ── Confetes caindo (subtle, poucos) ── */}
      {CONFETES.map((c, i) => (
        <div
          key={i}
          className="animate-junina-confete pointer-events-none absolute top-0"
          style={{
            left:              `${c.left}%`,
            animationDelay:    c.delay,
            animationDuration: '3s',
            width:             5,
            height:            5,
            borderRadius:      1,
            background:        c.cor,
            opacity:           0.7,
          }}
        />
      ))}

      {/* ── Fundo com gradiente quente ── */}
      <div className="bg-[linear-gradient(to_bottom,rgba(120,53,15,0.18)_0%,rgba(234,179,8,0.06)_60%,transparent_100%)] border-b border-yellow-500/[0.12] pb-2">
        {/* ── Varal de bandeirinhas ── */}
        <div className="relative px-0 pt-0">
          {/* Fio do varal */}
          <div className="absolute top-2 inset-x-0 h-px bg-[linear-gradient(to_right,transparent,rgba(161,120,10,0.5)_10%,rgba(161,120,10,0.5)_90%,transparent)]" />

          {/* Bandeirinhas triangulares em SVG */}
          <svg
            width="100%"
            height="24"
            viewBox={`0 0 ${totalBandeiras * 18} 24`}
            preserveAspectRatio="none"
            aria-hidden
          >
            {Array.from({ length: totalBandeiras }, (_, i) => {
              const cor   = CORES_VARAL[i % CORES_VARAL.length];
              const x     = i * 18 + 1;
              return (
                <polygon
                  key={i}
                  points={`${x},2 ${x + 14},2 ${x + 7},20`}
                  fill={cor}
                  opacity={0.88}
                  className="animate-junina-balanco"
                  style={{
                    transformOrigin: `${x + 7}px 2px`,
                    animationDelay:  `${i * 60}ms`,
                  }}
                />
              );
            })}
          </svg>
        </div>

        {/* ── Texto festivo ── */}
        <div className="flex items-center justify-center gap-2 pt-1">
          <p
            className="animate-junina-titulo-glow font-black uppercase text-center text-[10px] tracking-[0.22em] text-yellow-200/90"
            style={{ textShadow: SHADOW_JUNINA_TEXT }}
          >
            Invasão Junina
          </p>
        </div>
      </div>
    </div>
  );
}
